import { Button, ColumnTable } from '@octano/global-ui';
import { useObservationTexts } from './useObservationTexts';
import { useMemo } from 'react';
import { useHistory } from 'react-router';
import {
  StudentRiskEvaluationEnrollmentState,
  StudentRiskObservationsListRow,
} from '../types';
import RiskLevelBadge from '../parts/RiskLevelBadge';
import { BadgeStatus } from '../views/studentSessionDetail/parts/BadgeStatus';
import { PathsLayouts } from '../../../config/routes';

export function useObservationsColumns() {
  const { columns: columnsTexts } = useObservationTexts();
  const history = useHistory();

  const columns: ColumnTable<StudentRiskObservationsListRow>[] = useMemo(() => {
    return [
      {
        headerText: columnsTexts.student,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'student',
        cellFormat: ({ row }) => {
          return (
            <div className="d-block text-center">
              <span className="d-block">{row.name}</span>
              <strong className="d-block">{row.identification}</strong>
            </div>
          );
        },
      },
      {
        headerText: columnsTexts.studyPlan,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'studyPlan',
      },
      {
        headerText: columnsTexts.campus,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'campus',
      },
      {
        headerText: columnsTexts.graduatedYear,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'graduatedYear',
        cellFormat: ({ row }) => {
          return row.promo;
        },
      },
      {
        headerText: columnsTexts.course,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'course',
      },
      {
        headerText: columnsTexts.levelRisk,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'levelRisk',
        cellFormat: ({ row }) => (
          <RiskLevelBadge riskLevel={row.calculatedRiskLevel} />
        ),
      },
      {
        headerText: columnsTexts.situation,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'situation',
        cellFormat: ({ row }) => {
          return (
            <BadgeStatus
              active={row.state === StudentRiskEvaluationEnrollmentState.Active}
            />
          );
        },
      },
      {
        headerText: columnsTexts.conditionality,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'conditionality',
        cellFormat: ({ row }) => {
          return row.conditionality ? 'Si' : 'No';
        },
      },
      {
        headerText: columnsTexts.actions,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'actions',
        cellFormat: ({ row }) => {
          return (
            <Button
              text="gestionar"
              size="sm"
              onClick={() => {
                history.push(
                  `${PathsLayouts.studentWarnings}/observations/details/${row.studentId}/${row.studyPlanEnrollmentId}/${row.periodId}/${row.year}`,
                );
              }}
            />
          );
        },
      },
    ];
  }, [columnsTexts, history]);
  return columns;
}
